import React from "react";
import SimilarContentTabView from "./components/similar-content-tab-view/SimilarContentTabView";

const SimilarContentTab = ({ informationId = 0, onOpenAdditionalSidePanel }) => (
	<SimilarContentTabView informationId={informationId} onOpenAdditionalSidePanel={onOpenAdditionalSidePanel} />
);

export default SimilarContentTab;
